<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Transaksi QR V2</h5>
            </template>
            <div>
                 <div class="search-wrapper d-flex align-items-center justify-content-between">
                    <b-form-group
                        label="Filter"
                        label-for="filterInput"
                        class="form-inline form-group-wrapper mb-3"
                    >
                        <div class="d-flex search-input-wrapper">
                            <b-form-input class="ml-2 mr-2"
                                v-model="filter.noFaktur"
                                id="filterInput"
                                type="search"
                                placeholder="Masukkan no. faktur"
                            />
                            <b-form-select v-model="filter.status" class="mr-2">
                                <b-select-option value="-1">Semua Status</b-select-option>
                                <b-select-option value="0">Baru</b-select-option>
                                <b-select-option value="1">Terbayar</b-select-option>
                                <b-select-option value="2">Void</b-select-option>
                            </b-form-select>
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="getItems()"> 
                                <i class="fa fa-search"></i>
                            </b-button>
                            <b-button variant="pgiBtn" name="reseFilterBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                        </div>
                    </b-form-group>
                </div>
                <b-table bordered hover show-empty 
                    :busy="isBusy" 
                    :items="items"
                    :fields="fields"
                    responsive class="mb-3"
                >
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Mengambil data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data transaksi QR V2.
                    </template>
                    <template v-slot:cell(noKwitansi)="row">
                        <p class="mb-0">{{row.item.noKwitansi}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.noFaktur}}</p>
                    </template>
                    <template v-slot:cell(namaAnggota)="row">
                        <p class="mb-0">{{row.item.namaAnggota}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.noAnggota}}</p>
                    </template>
                    <template v-slot:cell(barang)="row">
                        <p class="mb-0">{{row.item.jenisBarang}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.merkBarang}} - {{row.item.tipeBarang}}</p>
                    </template>
                    <template v-slot:cell(jenis)="row">
                        <p class="mb-0" v-if="row.item.jenis == 'Perpanjangan + Cicilan Pokok'">Perpanjangan</p>
                        <p class="mb-0" v-else>{{row.item.jenis}}</p>
                    </template>
                    <template v-slot:cell(nominalPembayaran)="row">
                        <div class="text-right no-wrap">
                            <p class="mb-0" v-if="row.item.nominalPembayaran == null">{{$helper.addThousandSeparator(row.item.nominalPembayaran)}} </p>
                            <p class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalPembayaran)}} </p>
                        </div>
                        <div class="text-right no-wrap smallText text-muted">
                            <p class="mb-0" v-if="row.item.angsuranPokok == null">Angsuran{{$helper.addThousandSeparator(row.item.angsuranPokok)}} </p>
                            <p class="mb-0" v-else>Angsuran Rp. {{$helper.addThousandSeparator(row.item.angsuranPokok)}} </p>
                        </div>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge variant="dark" v-if="row.item.status == 'Baru'">BARU</b-badge>
                        <b-badge variant="success" v-else-if="row.item.status == 'Terbayar'">TERBAYAR</b-badge>
                        <b-badge variant="danger" v-else-if="row.item.status == 'Void'">VOID</b-badge>
                        <b-badge variant="warning" v-else-if="row.item.status == 'Request Void'">REQUEST VOID</b-badge>
                        <b-badge v-else>{{ row.item.status }}</b-badge>
                    </template>
                    <template v-slot:head(status)>
                        Status 
                        <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                    </template>
                    <template v-slot:cell(action)="row">
                        <div v-if="row.item.status == 'Baru'" class="no-wrap">
                            <b-button size="sm" class="mr-2" variant="dark" v-b-tooltip.hover title="Print Struk QR V2" @click="getQRISStruk(row.item.id)">
                                <i class="fa fa-fw fa-print"></i>
                            </b-button>
                            <b-button size="sm" class="mr-2" variant="success" v-b-tooltip.hover title="Lihat QR V2" @click="getQRISImage(row.item.id)">
                                <i class="fa fa-fw fa-image"></i>
                            </b-button>
                            <b-button size="sm" variant="danger" v-b-tooltip.hover title="Void Transaksi" @click="confirmVoid(row.item)">
                                <i class="fa fa-fw fa-times"></i>
                            </b-button>

                            <b-button v-if="row.item.tipePelunasan==2" class="ml-2" size="sm" variant="dark" v-b-tooltip.hover title="Cetak Nota Hilang" @click="printNotaHilang(row.item.id)">
                                <i class="fas fa-clipboard"></i>
                            </b-button>
                        </div>
                        <div v-else-if="row.item.status == 'Terbayar'" class="no-wrap">
                            <b-button size="sm" variant="primary" v-b-tooltip.hover title="Cetak Kwitansi" @click="printKwitansi(row.item.id)">
                                <i class="fa fa-fw fa-print"></i>
                            </b-button>

                            <b-button v-if="row.item.tipePelunasan==2" class="ml-2" size="sm" variant="dark" v-b-tooltip.hover title="Cetak Nota Hilang" @click="printNotaHilang(row.item.id)">
                                <i class="fas fa-clipboard"></i>
                            </b-button>

                            <b-button v-if="row.item.jenis === 'Pelunasan' && IS_HAVE_PERMISSION_REQUEST_EDIT_TIPE_PELUNASAN" size="sm" class="ml-2" variant="warning" v-b-tooltip.hover title="Edit" @click="onShowModalEdit(row.item.id)">
                                <i class="fa fa-pencil-square-o text-white"></i>
                            </b-button>
                        </div>
                    </template>
                </b-table>
                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="show" @change="onLimitChange" :options="options">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewText }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
            </div>
            <!-- <div class="small text-muted font-weight-bold mt-3">
                * Total pembayaran diluar biaya transaksi QR V2 sebesar 1% dibulatkan ke ratusan diatas.
            </div> -->
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">BARU</h6>
                <p class="smallText mb-0">Transaksi pembayaran yang baru diinput dan belum ditransaksikan. Seluruh pembayaran BARU yang tidak dieksekusi, akan dihapus keesokan harinya.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">TERBAYAR</h6>
                <p class="smallText mb-0">Transaksi pembayaran sudah dieksekusi (kwitansi sudah dicetak, kas cabang sudah berubah).</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">VOID</h6>
                <p class="smallText mb-0">Transaksi pembayaran sudah digugurkan (VOID).</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">REQUEST VOID</h6>
                <p class="smallText mb-0">Transaksi pembayaran sedang dalam proses VOID.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-print-qris" title="Print Struk QR V2" size="xl" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isFetching">
                Mengambil data struk QR V2, mohon menunggu...
            </div>
            <div v-else>
                <iframe width="100%" height="300" :src="qrisStrukPath" frameborder="0" allowfullscreen></iframe>
            </div>
        </b-modal>
        <b-modal id="modal-lihat-qris" title="Lihat QRIS" size="sm" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isFetching">
                Mengambil data struk QR V2, mohon menunggu...
            </div>
            <div v-else class="text-center">
            <img width="100%" :src="qrisImagePath" />
            <div class="text-center mt-3 flex gap-2 justify-center items-center">
                <b-button variant="primary" :disabled="!qrisURL" @click="viewQrisURL" class="mr-2">
                    Buka Link
                </b-button>
                <b-button variant="secondary" :disabled="!qrisURL" @click="copyQrisURL">
                    Salin Link
                </b-button>
            </div>

                <span v-if="copied" class="text-green-500 text-sm text-center">Link Copied!</span>
        </div>
        </b-modal>
        <b-modal id="modal-void" title="Void Transaksi" no-close-on-backdrop no-close-on-esc hide-footer :hide-header-close="isSubmitting">
            Lakukan void untuk transaksi QR V2 (NF {{ activeItem.noFaktur }}) ini?
            <div class="mt-4 text-right">
                <b-button class="mr-2" :disabled="isSubmitting" @click="$bvModal.dismiss('modal-void')">
                    Batalkan
                </b-button>
                <b-button variant="danger" :disabled="isSubmitting" @click="executeVoid">
                    {{ isSubmitting ? "Mohon menunggu..." : "Void" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-print-kwitansi" title="Kwitansi" size="xl" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isFetching">
                Mengambil data struk, mohon menunggu...
            </div>
            <div v-else>
                <iframe width="100%" height="300" :src="kwitansiPath" frameborder="0" allowfullscreen></iframe>
            </div>
        </b-modal>

        <b-modal id="modal-print-nota-hilang" title="Nota Hilang" size="xl" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isFetching">
                Mengambil data nota hilang, mohon menunggu...
            </div>
            <div v-else>
                <iframe width="100%" height="300" :src="notaHilangPath" frameborder="0" allowfullscreen></iframe>
            </div>
        </b-modal>

        <ModalEditTipePelunasan
            :editState="editState"
            :formEdit="formEdit"
            @submit="onSubmitEdit"
        />
    </div>
</template>

<script>
import CONSTANTS from '@/constants'
import ModalEditTipePelunasan from '@/components/modals/ModalEditTipePelunasan.vue'

export default {
    name: "kasir-transaksi-online",
    components: {
        ModalEditTipePelunasan,
    },
    data() {
        return {
            copied : false,

            initStatus: 0,
            isBusy: true,
            show: 10,

            isFetching: false,
            isSubmitting: false,
            activeId: 0,
            qrisStrukPath: "",
            qrisImagePath: "",
            qrisURL: "",
            kwitansiPath: "",
            notaHilangPath: "",

            input: {
                sortDesc: null,
                sortBy: null,
                sortDesc: null
            },

            filter: {
                noFaktur: "",
                status: "-1"
            },

            fields: [
                { key: "noKwitansi", label: "No. Kwitansi & Faktur" },
                { key: "namaAnggota", label: "Anggota" },
                { key: "barang", label: "Barang" },
                { key: "jenis", label: "Jenis Pembayaran" },
                { key: "nominalPembayaran", label: "Total Pembayaran" },
                { key: "status", label: "Status" },
                // { key: "counterPrint", label: "# Print" },
                { key: "action", label: "Aksi" }
            ],

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            items: [],
            activeItem: {},
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            totalViewText: "",
            formEdit: {
                tipePelunasan: null,
                isLoading: false,
            },
            editState: {
                isLoading: false,
                isError: false,
                data: null,
            },
        }
    },
    methods: {

        init() {

            this.initStatus = 0

            this.getItems().then(() => {
                this.initStatus = 1
            })

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)
            param += "&doku=true"
            param += "&cabangId=" + this.$helper.getCabangId()

            if(!this.$helper.isNullOrEmpty(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            return this.$axios.get("gadai-pembayaran/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

                let pg = this.currentPage - 1

                let prev = pg * this.show + 1
                let limit = pg * this.show + this.show
                if (limit > this.totalRows) limit = this.totalRows

                this.totalViewText = "Menampilkan "+ prev + " - " + limit + " dari " + this.totalRows + " entri"

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        getQRISStruk(id) {

            this.$bvModal.show("modal-print-qris")

            this.isFetching = true
            this.$axios.get("/gadai-pembayaran/print-qris-v2/" + id).then(res => {
                this.qrisStrukPath = this.$baseFilePath + res.data.name
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => this.isFetching = false)

        },

        getQRISImage(id) {

            this.$bvModal.show("modal-lihat-qris")

            this.isFetching = true
            this.$axios.get("/gadai-pembayaran/qr-code-image-v2/" + id).then(res => {
                this.qrisImagePath = res.data.name
                const urlParts = res.data.name.split("text=");
                const encodedText = urlParts[1];
                this.qrisURL = decodeURIComponent(encodedText);
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => this.isFetching = false)

        },

        confirmVoid(item) {
            this.activeItem = item
            this.$bvModal.show("modal-void")
        },

        executeVoid() {

            this.isSubmitting = true
            let payload = new FormData()
            payload.append("gadaiPembayaranId", this.activeItem.id)

            this.$axios.post("/gadai-pembayaran/cancel-qris-v2", payload).then(() => {
                
                this.$helper.toastSucc(this, "Transaksi berhasil divoid!")
                this.$bvModal.hide("modal-void")
                this.init()

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        printKwitansi(id) {

            this.$bvModal.show("modal-print-kwitansi")

            this.isFetching = true
            let payload = new FormData()
            payload.append("pembayaranId", id)

            this.$axios.post("/gadai-pembayaran/cetak-kwitansi", payload).then(res => {
                this.kwitansiPath = this.$baseFilePath + res.data.name
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => this.isFetching = false)

        },
        printNotaHilang(id) {
            this.$bvModal.show("modal-print-nota-hilang")
            this.isFetching = true

            this.$axios.get(`/gadai-evidence/get-nota-hilang?gadaiPembayaranId=${id}`).then(res => {
                this.notaHilangPath = this.$baseFilePath + res.data.name
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => this.isFetching = false)

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        onReset() {
            this.filter.noFaktur = ""
            this.filter.status = -1
            this.getItems()
        },
        viewQrisURL() {
        if (this.qrisURL) {
        window.open(this.qrisURL, "_blank");
        }
        },

        copyQrisURL() {
        navigator.clipboard.writeText(this.qrisURL)
            .then(() => {
                this.copied = true;
                setTimeout(() => this.copied = false, 1500);
            })
            .catch(() => alert("Gagal menyalin link"));
        },
        onShowModalEdit(id) {
            this.editState.isLoading = true
            this.editState.isError = false
            this.editState.data = null

            this.$bvModal.show("modal-edit")

            this.$axios.get(`gadai-pembayaran/${id}`)
                .then((response) => {
                    this.editState.data = response.data
                    this.formEdit.tipePelunasan = response.data.tipePelunasan
                })
                .catch((error) => {
                    this.editState.isError = true
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.editState.isLoading = false
                })
        },
        onSubmitEdit(form) {
            const id = this.editState.data.noFaktur;
            const type = form.tipePelunasan;
            this.formEdit.isLoading = true;

            this.$axios.put(`gadai-evidence/update-tipe/${id}?newTipe=${type}`)
                .then(() => {
                    this.$helper.toastSucc(this, "Perubahan berhasil diajukan. Menunggu persetujuan.")
                    this.$bvModal.hide("modal-edit")
                })
                .catch((error) => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.$bvModal.hide("modal-confirm-edit-tipe-pelunasan")
                    this.formEdit.isLoading = false
                })
        }
    },
    computed: {
        IS_HAVE_PERMISSION_REQUEST_EDIT_TIPE_PELUNASAN() {
            const permissionRequestEditTipePelunasan = CONSTANTS.PERMISSION.EDIT_TIPE_PELUNASAN.REQUEST;
            return this.$helper.hasPermissionMenuChildren(permissionRequestEditTipePelunasan)
        }
    },
    created() {
        this.init()
    }
}  
</script>